<template>
  <transition :name="transitionName" @after-leave="$_onAfterLeave" @before-enter="$_onBeforeEnter">
    <div v-show="model" :class="classes">
      <div :class="mainClasses">
        <t-icon icon="loading"></t-icon>
        <div v-if="tip || $slots.default" :class="contentClass">
          <slot>{{ tip }}</slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { PREFIX_CLASS } from '@/utils/constants'
import TIcon from '@/module/icon'
import locale from '@/mixins/locale'
import { removeClass, addClass } from '@/utils/helper'
const PREFIXCLS = `${PREFIX_CLASS}loading`

export default {
  name: 'TLoading',
  components: {
    TIcon
  },
  mixins: [ locale ],
  props: {
    transitionName: {
      type: String,
      default: 'fade'
    },
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      validator(value) {
        return ['sm', 'lg', 'md'].includes(value)
      }
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS
    }
  },
  computed: {
    classes () {
      return [
        `${this.prefixCls}`,
        {
          [`${this.prefixCls}--${this.size}`]: !!this.size,
          [`${this.prefixCls}--fix`]: this.fullscreen
        }
      ]
    },
    mainClasses () {
      return `${this.prefixCls}__main`
    },
    contentClass () {
      return `${this.prefixCls}__tip`
    },
    model: {
      get (value) {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value (val) {
      let parentNode = this.$el && this.$el.parentNode
      let position = parentNode && parentNode.originalPosition ? parentNode.originalPosition : parentNode.style.position
      if (val) {
        if (position !== 'absolute' && position !== 'fixed') {
          addClass(parentNode, `${this.prefixCls}__relative`)
        }
      } else {
        removeClass(parentNode, `${this.prefixCls}__relative`)
      }
    }
  },
  methods: {
    $_onAfterLeave () {
      this.$emit('after-leave')
    },
    $_onBeforeEnter () {
      this.$emit('before-enter')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/loading/index.vue